import { ListFilters } from "apps/customLists/components/filterScreens";
import { useGetTagsAndTagGroupsByListFilters } from "apps/customLists/hooks";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FilterKey, filterOptions } from "shared/components";
import { getFilterTagData } from "shared/utils";

export type UseListCriteriaProps = {
  widgetFilters: ListFilters | undefined;
};

export const useListCriteria = ({ widgetFilters }: UseListCriteriaProps) => {
  const { t } = useTranslation();

  const { tags, tagGroups, error, loading } =
    useGetTagsAndTagGroupsByListFilters(widgetFilters);

  const [filteredTagData, setFilteredTagData] = useState<
    { key: FilterKey; tags: string[] }[]
  >([]);

  useEffect(() => {
    if (!widgetFilters || !tags || !tagGroups) {
      return;
    }

    setFilteredTagData(
      filterOptions
        .map((filterOption) => ({
          key: filterOption.key,
          tags: getFilterTagData(
            t,
            filterOption,
            widgetFilters,
            tags,
            tagGroups,
          ),
        }))
        .filter((filterInfo) => filterInfo.tags.length > 0),
    );
  }, [t, tags, tagGroups, widgetFilters]);

  return {
    filteredTagData,
    error,
    loading,
  };
};
